import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-journey-view',
  templateUrl: './journey-view.component.html',
  styleUrls: ['./journey-view.component.scss']
})
export class JourneyViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
